module.exports = __webpack_public_path__ + "img/upload-photo-full.f01c7bf7.svg";